




























import mixins from 'vue-typed-mixins'
import DraftElement from '@/builder/sections/mixins/DraftElement'
import CCalendarLocationPanel from '@/builder/sections/section/calendars/components/CCalendarLocationPanel.vue'
import CCalendarSearchPreview from '@/builder/sections/section/calendars/components/CCalendarSearchPreview.vue'

export default mixins(DraftElement).extend({
  name: 'CCalendarLocationsPreview',
  components: {
    CCalendarLocationPanel,
    CCalendarSearchPreview
  },
  props: {
    selectLocationsTitle: {
      type: String,
      default: ''
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    classForViewRound: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    }
  }
})
